define('models/user-settings',[
  'models/base/model',
  'lib/utils'
], function(Model, utils) {
    'use strict';

    var UserSettings = Model.extend({
        urlPath: '/api/user/settings',
        defaults: {
            managerWidgetExpanded: true,
            currencyWidgetExpanded: true,
            accountWidgetExpanded: true,
            multiAccountWidgetExpanded: true,
            sidebarExpanded: true
        }
    });

    return UserSettings;
});
